/* CWV Hero — finish swatches.
   Button swatches (no URL): tap to preview a film finish on the photo.
   Link swatches (URL set): a finish tooltip on hover/focus, kept inside the viewport and
   dismissable with Escape. */
(function () {
  'use strict';

  function placeTip(wrap) {
    var tip = wrap.querySelector('.cwv-hero__tip');
    if (!tip) return;
    tip.style.setProperty('--tip-dx', '0px');
    var r = tip.getBoundingClientRect();
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var pad = 12;
    var dx = 0;
    if (r.left < pad) dx = pad - r.left;
    else if (r.right > vw - pad) dx = (vw - pad) - r.right;
    if (dx) tip.style.setProperty('--tip-dx', Math.round(dx) + 'px');
  }

  function initTips(group) {
    var wraps = group.querySelectorAll('[data-cwv-sw-tip]');
    if (!wraps.length) return;
    Array.prototype.forEach.call(wraps, function (wrap) {
      var show = function () { wrap.classList.remove('is-tip-off'); placeTip(wrap); };
      wrap.addEventListener('mouseenter', show);
      wrap.addEventListener('focusin', show);
      wrap.addEventListener('mouseleave', function () { wrap.classList.remove('is-tip-off'); });
      wrap.addEventListener('focusout', function () { wrap.classList.remove('is-tip-off'); });
    });
    group.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var wrap = e.target.closest ? e.target.closest('[data-cwv-sw-tip]') : null;
      if (wrap) wrap.classList.add('is-tip-off');
    });
  }

  function init(scope) {
    var groups = (scope || document).querySelectorAll('[data-cwv-swatches]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.cwvReady) return;
      group.cwvReady = true;
      var out = document.getElementById(group.getAttribute('data-cwv-swatches'));
      var hero = group.closest('.cwv-hero');
      var tint = hero ? hero.querySelector('[data-cwv-tint]') : null;

      initTips(group);

      group.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('button[data-finish]') : null;
        if (!btn || !group.contains(btn)) return;
        var finish = btn.getAttribute('data-finish');
        Array.prototype.forEach.call(group.querySelectorAll('button[data-finish]'), function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (out) out.textContent = btn.getAttribute('data-desc') || '';
        if (hero) hero.setAttribute('data-finish', finish);
        if (tint) tint.className = 'cwv-hero__tint is-on sw-' + finish;
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
